import autocomplete from 'autocompleter';
import $ from 'jquery';

/**
 * spritzung_autocompleteAufzeichnung
 * @param elementID
 * @param helperFile
 * @param einsatzdatumStart
 */
window.spritzung_autocompleteAufzeichnung = function(elementID, helperFile, einsatzdatumStart = '') {
  // input
  const input = document.getElementById(elementID);
  input.setAttribute('autocomplete', 'off');

  const row = $(input).closest('div.psm-mittel-row');
  const recordID = $('#app__content').data('id');

  $(input).on('keyup', function() {
    if ($(this).val() === '') {
      spritzung_bindClearMittel();
    }
  });

  autocomplete({
    emptyMsg: LANG_STRINGS.noResults,
    minLength: 1,
    input: input,
    preventSubmit: true,
    debounceWaitMs: 300,
    className: 'autocomplete-additional',
    fetch: function(text, update) {
      if ($(input).hasClass('readonly')) {
        return false;
      }

      text = text.toLowerCase();

      let selectedSpritzmittel = [];
      let selectedDuengemittel = [];
      let selectedSections = [];

      $('#table-mittel').find('div.row:not(.row-table__head)').each(function() {
        if ($(this).data('psm-key') === 'psm' && $(this).data('psm-id') !== '') {
          selectedSpritzmittel.push($(this).data('psm-id'));
        } else if ($(this).data('psm-key') === 'duenge' && $(this).data('psm-id') !== '') {
          selectedDuengemittel.push($(this).data('psm-id'));
        }
      });

      $.each($('input.check_section:checked'), function() {
        selectedSections.push($(this).val());
      });

      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/autocomplete/' + helperFile,
        type: 'post',
        data: {
          type: elementID,
          search: text,
          recordID: recordID,
          einsatzdatumStart: einsatzdatumStart,
          selectedSections: selectedSections,
          excludeSpritzmittel: selectedSpritzmittel,
          excludeDuengemittel: selectedDuengemittel,
          additionalData: getCultureQuality(),
        },
        dataType: 'json',
        success: function(response) {
          let suggestions = Array();

          $.each(response, function(i, obj) {
            let valueData = Array();
            for (let key in obj) {
              valueData[key] = obj[key];
            }

            suggestions.push({
              'label': valueData['name'],
              'value': valueData,
            });
          });

          const itemCount = suggestions.length;
          if (itemCount === 0) {
            suggestions.push({
              'label': '',
              'value': '',
            });
            update(suggestions);
          }

          update(suggestions);

          // render mittelanfrage
          renderMittelanfrage('.autocomplete-additional', 'spritzung');
        },
      });
    },
    render: function(item) {
      let div = document.createElement('div');

      $(div).addClass(item.value.zulassungsstatus_id_css);

      if (item.value.lagerbestand !== undefined) {
        const lagerbestand = (item.value.lagerbestand !== '' ? numberFormatAuto(item.value.lagerbestand, 2, 2) : '-.-');
        const lagerbestandEinheit = item.value.lagerbestand_einheit || '';

        div.innerHTML = '<span class=\'with-lager\'>' + item.label + '</span><span class=\'with-lager\'>' + lagerbestand + ' ' + lagerbestandEinheit + '</span>';
      } else {
        div.innerHTML = item.label;
      }

      return div;
    },
    onSelect: function(item) {
      // zu Beginn die Zeile leeren
      spritzung_bindClearMittel();

      const label = item.label;
      const tempLabel = label.replace(/\<strong\>/gi, '');
      const temp = tempLabel.replace(/\<\/strong\>/gi, '');

      const valueData = item.value;
      const mittelID = valueData['uid'];
      const url = valueData['psm_url'];

      if (valueData.dataKey !== 'duenge') {
        spritzung_loadIndications(row, mittelID, recordID);
      }
      spritzung_bindIndicationSelect(row, mittelID, recordID, valueData.dataKey);

      row.attr('data-wirkstoffgroups', valueData.psm_wirkstoffgruppen_ids);

      input.label = temp;
      input.value = temp;

      row.attr('data-key', valueData.dataKey);
      row.find('.data_key').val(valueData.dataKey);

      // Dosis Einheit
      row.find('.dosisProHlGui').removeAttr('readonly');
      row.find('.dosisProHlGui').closest('label').find('span.icon-after').html(valueData.psm_dosage_unity_name);
      row.find('.dosage_single_unity').val(valueData.psm_dosage_unity_id);
      row.find('.dosage_single_unity').attr('data-faktor', valueData.psm_dosage_unity_faktor);

      // Mittel-Menge Einheit
      row.find('.sumMittelmengeGui').removeAttr('readonly');
      row.find('.sumMittelmengeGui').closest('label').find('span.icon-after').html(valueData.psm_dosage_unity_name);
      row.find('.spray_amount_unity').val(valueData.psm_dosage_unity_id);
      row.find('.spray_amount_unity').attr('data-faktor', valueData.psm_dosage_unity_faktor);

      // Mittel-Menge pro ha und Einsatz
      row.find('.sumMittelmengeProHaGui').removeAttr('readonly');
      row.find('.sumMittelmengeProHaGui').closest('label').find('span.icon-after').html(valueData.psm_dosage_unity_name);
      row.find('.spray_amount_per_ha_unity').val(valueData.psm_dosage_unity_id);
      row.find('.spray_amount_per_ha_unity').attr('data-faktor', valueData.psm_dosage_unity_faktor);

      row.find('.indicationSelect, .psm_restriction_use_period ').removeAttr('readonly');
      row.find('.psm_restriction_use_period').val(valueData.psm_restriction_use_period).addClass('newTooltip');

      row.attr('data-psm-id', valueData.uid);
      row.find('.psm_mittel_uid').val(valueData.uid);
      row.find('.psm_mittel_parent_uid').val(valueData.parent_uid);
      row.find('.psm_mittel_archived').val(valueData.archived);

      checkIconAfterLength();

      // Button Teilspritzung
      $('button#mittel-teilspritzung-button').removeClass('display-none');

      // Button Database
      $('button#mittel-database-button').attr('data-url', url).removeAttr('disabled');

      // Button Bemerkung
      $('button#mittel-bemerkung-button').removeAttr('disabled');

      // Input Settings
      $(input).attr('readonly', 'readonly');
      $(input).closest('.form-field').removeClass('form-field--error');
      $('#remove-mittel-element').removeClass('display-none');
    },
  });
};

/**
 * spritzung_loadIndications
 * @param row
 * @param mittelID
 * @param recordID
 */
window.spritzung_loadIndications = function(row, mittelID, recordID) {
  const select = row.find('select.indicationSelect');

  const response = $.ajax({
    type: 'POST',
    url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAufzeichnungWirkung?type=pflanzenschutz',
    async: true,
    data: {
      mittelID: mittelID,
      recordID: recordID,
    },
  }).done(function() {
    const indications = $.parseJSON(response.responseText);

    // Erst leeren
    select.find('option').remove();

    if (indications.length > 0) {
      $.each(indications, function(i, wirkung) {
        // Wirkung
        let wirkungName = wirkung.originalName;

        // Nebenwirkung
        const nebenwirkungName = wirkung.sideeffectName;
        if (nebenwirkungName !== '') {
          wirkungName = wirkungName + ' / ' + nebenwirkungName;
        }

        select.append('<option value="' + wirkung.value + '" data-sideeffect-id="' + wirkung.sideeffectID + '" data-sideeffect-name="' + wirkung.sideeffectName + '" ' + wirkung.selected + '>' + wirkungName + '</option>');
      });

      select.focus();
      select.click();
      select.find('option').first().attr('selected', true);
      select.attr('autoselect', true);
      select.trigger('change');
    } else {
      row.find('input.dosage_input').focus();
    }
  });
};

/**
 * spritzung_bindIndicationSelect
 * @param row
 * @param mittelID
 * @param recordID
 * @param dataKey
 */
window.spritzung_bindIndicationSelect = function(row, mittelID, recordID, dataKey) {
  if (dataKey === 'duenge') {
    const usePeriodField = row.find('.psm_restriction_use_period');
    const response = $.ajax({
      type: 'POST',
      url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAufzeichnungZeitspanne?type=pflanzenschutz&key=duenge',
      async: true,
      data: {
        mittelID: mittelID,
        recordID: recordID,
        selectedUsePeriodID: usePeriodField.find('option:selected').val(),
      },
    }).done(function() {
      const useperiodsData = $.parseJSON(response.responseText);

      // Erst leeren
      usePeriodField.find('option').remove();

      if (useperiodsData.length > 0) {
        $.each(useperiodsData, function(i, result) {
          usePeriodField.append('<option value="' + result.value + '" ' + result.selected + '>' + result.name + '</option>');
        });
        usePeriodField.trigger('change');
      }

      spritzung_bindHinweise(recordID, mittelID, dataKey, 0, usePeriodField.find('option:selected').val());
    });
  } else {
    $('select.indicationSelect').on('change', function() {
      const select = $(this);
      const row = select.closest('div.psm-mittel-row');
      const option = select.find('option:selected');

      const sideeffectCell = select.closest('div.psm-mittel-row').find('.psm-indication-sideeffect');
      sideeffectCell.val(option.data('sideeffect-id'));

      const indicationID = option.val();
      const mittelID = row.attr('data-psm-id');
      const dataKey = row.attr('data-key');
      const recordID = $('#app__content').data('id');
      const usePeriodField = row.find('.psm_restriction_use_period');

      const response = $.ajax({
        type: 'POST',
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAufzeichnungZeitspanne?type=pflanzenschutz',
        async: true,
        data: {
          indicationID: indicationID,
          sideeffectID: sideeffectCell.val(),
          mittelID: mittelID,
          recordID: recordID,
          selectedUsePeriodID: usePeriodField.find('option:selected').val(),
        },
      }).done(function() {
        const useperiodsData = $.parseJSON(response.responseText);

        // Erst leeren
        usePeriodField.find('option').remove();

        if (useperiodsData.length > 0) {
          $.each(useperiodsData, function(i, result) {
            usePeriodField.append('<option value="' + result.value + '" ' + result.selected + '>' + result.name + '</option>');
          });

          usePeriodField.trigger('change');
          const indicationSelect = row.find('select.indicationSelect');
          const options = indicationSelect.find('option');
          if (options.length < 2) {
            row.find('select.psm_restriction_use_period').focus();
            row.find('select.psm_restriction_use_period').click();
          }
        }

        spritzung_bindHinweise(recordID, mittelID, dataKey, indicationID, usePeriodField.find('option:selected').val());
      });
    });
  }
};

/**
 * spritzung_bindHinweise
 * @param recordID
 * @param mittelID
 * @param dataKey
 * @param indicationID
 * @param psmRestrictionUsePeriod
 */
window.spritzung_bindHinweise = function(recordID, mittelID, dataKey, indicationID, psmRestrictionUsePeriod) {
  $('.mittel-hinweise').html('').addClass('display-none');

  // Hinweise
  $.ajax({
    type: 'POST',
    url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getMittelControls?type=spritzung',
    async: true,
    data: {
      recordID: recordID,
      psmID: mittelID,
      dataKey: dataKey,
      psmIndication: indicationID,
      psmRestrictionUsePeriod: parseInt(psmRestrictionUsePeriod),
    },
    success: function(result) {
      if (result !== '') {
        $('.mittel-hinweise').html(result).removeClass('display-none');
      }
    },
  });
};

/**
 * spritzung_bindUsePeriodSelect
 */
window.spritzung_bindUsePeriodSelect = function() {
  const recordID = $('#app__content').data('id');

  $('.psm_restriction_use_period').on('change', function() {
    const select = $(this);
    const option = select.find('option:selected');
    const row = select.closest('div.psm-mittel-row');
    const indicationID = row.find('.psm_indication').val();
    const sideeffectID = row.find('.psm_indication option:selected').data('sideeffect-id');
    const useperiodID = option.val();
    const mittelID = row.attr('data-psm-id');
    const dataKey = row.attr('data-key');

    let key = '';
    if (dataKey === 'duenge') {
      key = '&key=duenge';
    }

    const response = $.ajax({
      type: 'POST',
      url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAufzeichnungDosageData?type=pflanzenschutz' + key,
      async: true,
      data: {
        indicationID: indicationID,
        sideeffectID: sideeffectID,
        useperiodID: useperiodID,
        mittelID: mittelID,
        recordID: recordID,
      },
    }).done(function() {
      const dosageData = $.parseJSON(response.responseText);
      spritzung_setDosageData(row, dosageData);

      const indicationSelect = row.find('select.indicationSelect');
      const indicationOptions = indicationSelect.find('option');
      const autoselect = indicationSelect.attr('autoselect');
      const periodSelect = row.find('select.psm_restriction_use_period');
      const periodOptions = periodSelect.find('option');

      if ((autoselect === undefined || indicationOptions.length < 2) && periodOptions.length < 2) {
        row.find('input.dosisProHl').focus();
        row.find('input.dosisProHl').click();
      }
      indicationSelect.removeAttr('autoselect');
    });
  });
};

/**
 * spritzung_setDosageData
 * @param row
 * @param data
 */
window.spritzung_setDosageData = function(row, data) {
  // Nebenwirkung
  const sideEffects = row.find('select.psm_indication_sideeffect');
  sideEffects.html('');
  const sideEffectPossibilitys = row.find('input.psm_indication_sideeffect_possibilitys');
  sideEffectPossibilitys.val('');
  const sideEffectPossibilitysArray = [];

  if (data['sideeffects'] !== undefined) {
    $.each(data['sideeffects'], function(id, name) {
      const option = $('<option value="' + id + '">' + name + '</option>');
      sideEffects.append(option);
      sideEffectPossibilitysArray.push(id);
    });

    sideEffectPossibilitys.val(sideEffectPossibilitysArray.join(','));
  }

  // Max. Anwendung gesamt
  const maxApplications = row.find('.psm_dosage_max_apply');
  if (data['maxApplications'] != null && data['maxApplications'] !== undefined) {
    maxApplications.val(data['maxApplications']);
  }

  // Min Dosierung
  let recommendTextMin = '';
  const minDosageHidden = row.find('.psm_dosage_recommended_sbr_min_per_hl');
  minDosageHidden.val(data['minDosage']);
  if (data['minDosage'] != null && data['minDosage'] !== undefined) {
    recommendTextMin = data['minDosage'];
  }

  // Max Dosierung
  let recommendTextMax = '';
  const maxDosageHidden = row.find('.psm_dosage_recommended_sbr_max_per_hl');
  maxDosageHidden.val(data['maxDosage']);
  if (data['maxDosage'] != null && data['maxDosage'] !== undefined) {
    recommendTextMax = data['maxDosage'];
  }

  // Dosierung Einheit
  const unity = row.find('.dosisProHlGui').closest('label').find('.icon-after').html();
  const unityID = row.find('.dosage_single_unity').val();
  const dosageUnity = row.find('.psm_dosage_recommended_sbr_unity');
  dosageUnity.val('');

  let recommendTextUnity = '';
  if (recommendTextMin !== '' || recommendTextMax !== '') {
    dosageUnity.val(unityID);
    recommendTextUnity = unity;
  }

  // Dosierung Trenner
  let recommendTextDelimiter = '';
  if (recommendTextMin !== '' && recommendTextMax !== '') {
    recommendTextDelimiter = ' - ';
  }

  // Mittelmenge max/ha
  const maxPerHaAndApplication = row.find('.psm_dosage_per_ha_sprayamount_max_sbr');
  if (data['maxPerHaAndApplication'] !== '' && data['maxPerHaAndApplication'] != null && data['maxPerHaAndApplication'] !== undefined) {
    let maxPerHaAndApplicationValue = data['maxPerHaAndApplication'];
    maxPerHaAndApplicationValue = maxPerHaAndApplicationValue.replaceAll('.', '');

    maxPerHaAndApplication.val(maxPerHaAndApplicationValue).closest('label').find('.icon-after').html(unity);
  } else {
    maxPerHaAndApplication.val('').closest('label').find('.icon-after').html('&nbsp;');
  }

  // Set Empfehlung SBR Text
  const psmDosageRecommendedSbr = row.find('.psm_dosage_recommended_sbr');
  psmDosageRecommendedSbr.val('');

  var recommendText = recommendTextMin + recommendTextDelimiter + recommendTextMax + ' ' + recommendTextUnity;
  if (recommendTextMin === recommendTextMax) {
    recommendText = recommendTextMin + ' ' + recommendTextUnity;
  } else if (recommendTextMin === '') {
    recommendText = LANG_STRINGS.ab + ' ' + recommendTextMax + ' ' + recommendTextUnity;
  }
  psmDosageRecommendedSbr.val(recommendText);

  // show button
  const arrowAssume = $('.empfehlung-sbr-assume');
  arrowAssume.addClass('inactive').attr('data-dosage', '');

  // Wenn ein Betrieb oder ein Abschnitt mit Bio vorhanden ist und ein Mittel Kupfer enthält, soll der übernehmen-pfeil ebenfalls ausgegraut werden.
  const allQualites = [];
  $('input.all-qualities').each(function() {
    const qualityID = Number($(this).val());
    if (allQualites.indexOf(qualityID) === -1) {
      allQualites.push(qualityID);
    }
  });

  const containBio = inArray(Number($('#add-psm-modal').data('bio')), allQualites);
  const wirkstoffgroups = String(row.data('wirkstoffgroups'));
  let hasKupfer = false;
  if (wirkstoffgroups !== '') {
    const wirkstoffgroupList = wirkstoffgroups.split(',');
    if (wirkstoffgroupList.length > 0) {
      $.each(wirkstoffgroupList, function(key, value) {
        if (Number(value) === Number($('#add-psm-modal').data('kupfer'))) {
          hasKupfer = true;
          return false;
        }
      });
    }
  }

  const notAllowedAssume = (containBio && hasKupfer);

  if (!notAllowedAssume && recommendTextMin !== '' && recommendTextMax !== '' && recommendTextMin === recommendTextMax) {
    const minDosage = roundDosisProHlGui(reformatNumeric(data['minDosage'], 2));
    arrowAssume.removeClass('inactive');
    arrowAssume.attr('data-dosage', minDosage);
  }
};

/**
 * spritzung_changeZeitspanne
 * @param select
 */
window.spritzung_changeZeitspanne = function(select) {
  $.ajax({
    url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.getAufzeichnungChangeZeitspanne?type=pflanzenschutz',
    type: 'get',
    data: {
      zeitspanneSelected: $(select).val(),
    },
    success: function(response) {
      $(select).attr('title', response);
    },
  });
};

/**
 * spritzung_bindClearMittel
 */
window.spritzung_bindClearMittel = function() {
  const row = $('.psm-mittel-row');
  const inputsToClearAndReadable = row.find('.smittel, .psm_wirkstoff');
  inputsToClearAndReadable.each(function() {
    const input = $(this);
    input.removeAttr('readonly');
    input.removeClass('readonly');
    input.val('');
  });

  const inputsToClear = row.find(
      '.dosisProHlGui, .dosisProHl, ' +
      '.sumMittelmengeGui, .sumMittelmenge, ' +
      '.sumMittelmengeProHaGui, .sumMittelmengeProHa, ' +
      '.smittel, ' +
      '.psm_indication_sideeffect, ' +
      '.sideeffectname, ' +
      '.psm_mittel_uid, ' +
      '.psm_wirkstoff_ids, ' +
      '.psm_wirkstoff_group, ' +
      '.psm_wirkstoffgroup_ids, ' +
      '.psm_dangerous_for_bee, ' +
      '.psm_indication_sideeffect_possibilitys, ' +
      '.psm_dosage_recommended_sbr, ' +
      '.psm_dosage_recommended_sbr_min_per_hl, ' +
      '.psm_dosage_recommended_sbr_max_per_hl, ' +
      '.psm_dosage_recommended_sbr_unity, ' +
      '.psm_dosage_max_apply, ' +
      '.dosage_single_unity, ' +
      '.dosage_single_unity_name, ' +
      '.psm_dosage_per_ha_sprayamount_max_sbr, ' +
      '.data_key, ' +
      '.psm_mittel_parent_uid, ' +
      '.psm_mittel_archived, ' +
      '.psm_mittelgruppen_ids, ' +
      '.psm_restriction_legal, ' +
      '.psm_restriction_reentry, ' +
      '.psm_mittelgruppen_names,' +
      '.psm_mittel_teilspritzung,' +
      '.psm_teilspritzung_sections');
  inputsToClear.each(function() {
    const input = $(this);
    input.val('').removeClass('err');
  });

  const selectsToClear = row.find('select');
  selectsToClear.each(function() {
    const select = $(this);
    select.removeAttr('readonly').removeClass('err').removeClass('readonly');
    select.find('option').remove();
    select.val('').removeClass('err');
  });

  row.find('.smittel').css('cursor', 'auto').removeClass('err');

  row.find('.indicationSelect, .psm_restriction_use_period').attr('readonly', 'readonly');

  // Remove Units
  row.find('.dosisProHlGui').attr('readonly', 'readonly');
  row.find('.dosisProHlGui').closest('label').find('span.icon-after').html('&nbsp;');

  row.find('.sumMittelmengeGui').attr('readonly', 'readonly');
  row.find('.sumMittelmengeGui').closest('label').find('span.icon-after').html('&nbsp;');

  row.find('.sumMittelmengeProHaGui').attr('readonly', 'readonly');
  row.find('.sumMittelmengeProHaGui').closest('label').find('span.icon-after').html('&nbsp;');

  row.find('.psm_dosage_per_ha_sprayamount_max_sbr');
  row.find('.psm_dosage_per_ha_sprayamount_max_sbr').closest('label').find('span.icon-after').html('&nbsp;');

  // Empfehlungen entfernen
  row.find('.empfehlung-sbr-assume').addClass('inactive').attr('data-dosage', '');

  // Button Database
  $('button#mittel-database-button').removeAttr('data-url').attr('disabled', 'disabled');

  // Button Bemerkung
  $('button#mittel-bemerkung-button').attr('disabled', 'disabled').find('i.material-icons').hide();
  $('#mittel-bemerkung-text').val('');

  $('.mittel-hinweise').html('').addClass('display-none');

  const mittelUnterdosierungHtml = $('.mittel-unterdosierung');
  mittelUnterdosierungHtml.addClass('display-none');
  mittelUnterdosierungHtml.find('.bodytext').html('');

  const mittelUeberdosierungHtml = $('.mittel-ueberdosierung');
  mittelUeberdosierungHtml.addClass('display-none');
  mittelUeberdosierungHtml.find('.bodytext').html('');

  row.attr('data-psm-id', '');
  row.attr('data-key', '');
  row.find('.smittel').click();
  row.find('.smittel').focus();

  $('#remove-mittel-element').addClass('display-none');
};

/**
 * spritzung_buildMittelRow
 * @param json
 * @param divElement
 */
window.spritzung_buildMittelRow = function(json, divElement) {
  // Template
  let template = $('#mittel-row').html();

  $.each(json, function(k, v) {
    if (k === '__BEMERKUNG__') {
      v = v.replace(/<br ?\/?>/g, '\n');
    }
    template = template.replace(new RegExp(k, 'g'), v);
  });

  if ($(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').length > 0) {
    $(divElement).find('div[data-row-key="' + json.__KEY__ + '"]').replaceWith(template);
  } else {
    $(divElement).append(template);
  }
};

/**
 * spritzung_buildAbschnittMittelRow
 * @param json
 * @param divElement
 * @param isTeilspritzung
 */
window.spritzung_buildAbschnittMittelRow = function(json, divElement, isTeilspritzung) {
  let checkboxIdentifier = '.check_section';
  if (isTeilspritzung) {
    checkboxIdentifier = '.check_section-teilspritzung';
  }
  let tableMittelIdentifier = '.table-mittel-abschnitt';
  if (isTeilspritzung) {
    tableMittelIdentifier = '.table-mittel-abschnitt-teilspritzung';
  }
  let dataSection = 'data-section-uid';
  if (isTeilspritzung) {
    dataSection = 'data-teilspritzung-section-uid';
  }

  const checkedAbschnitte = $(divElement).find('input' + checkboxIdentifier + '[type="checkbox"]:checked');
  if (checkedAbschnitte.length > 0) {
    checkedAbschnitte.each(function() {
      const detailMittel = $(this).closest('.tree-item').find('div' + tableMittelIdentifier);

      // Template
      let template = '';
      if (isTeilspritzung) {
        template = $('#mittel-teilspritzung-abschnitt-row').html();
      } else {
        template = $('#mittel-abschnitt-row').html();
      }

      $.each(json, function(k, v) {
        template = template.replace(new RegExp(k, 'g'), v);
      });

      template = template.replace(new RegExp('__SECTION_ID__', 'g'), $(this).val());

      if (json.__ROW_ID__ !== '' && detailMittel.find('div.row[' + dataSection + '="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').length > 0) {
        detailMittel.find('div.row[' + dataSection + '="' + $(this).val() + '"][data-row-id="' + json.__ROW_ID__ + '"]').replaceWith(template);
      } else if (detailMittel.find('div.row[' + dataSection + '="' + $(this).val() + '"][data-psm-id="' + json.__PSM_ID__ + '"][data-psm-key="' + json.__PSM_KEY__ + '"]').length > 0) {
        detailMittel.find('div.row[' + dataSection + '="' + $(this).val() + '"][data-psm-id="' + json.__PSM_ID__ + '"][data-psm-key="' + json.__PSM_KEY__ + '"]').replaceWith(template);
      } else {
        detailMittel.append(template);
      }
    });
  }
};

/**
 * spritzung_checkUnterdosierung
 */
window.spritzung_checkUnterdosierung = function() {
  if ($('#add-psm-modal').length > 0) {
    setTimeout(function() {
      const mittelUnterdosierungHtml = $('.mittel-unterdosierung');

      const recordID = $('#app__content').data('id');
      const psmID = $('input.psm_mittel_uid').val();
      const dataKey = $('input.data_key').val();

      const dosisHl = $('input.dosisProHl').val();
      const dosisProHlGui = $('input.dosisProHlGui');
      const dosisUnity = $('input.dosage_single_unity').val();
      const sumMittelmengeGui = $('input.sumMittelmengeGui');
      const sumMittelmengeProHaGui = $('input.sumMittelmengeProHaGui ');

      const psmIndication = $('select.indicationSelect').val();
      const psmIndicationSideeffect = $('input.psm-indication-sideeffect').val();
      const psmRestrictionUsePeriod = $('select.psm_restriction_use_period').val();

      const isTeilspritzung = Number($('input.psm_mittel_teilspritzung').val()) === 1;

      const abschnitte = spritzung_buildAbschnittData(false, isTeilspritzung);

      $.ajax({
        type: 'POST',
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.checkUnterdosierung?type=spritzung',
        async: true,
        data: {
          recordID: recordID,
          psmID: psmID,
          dataKey: dataKey,
          dosisHl: dosisHl,
          dosisUnity: dosisUnity,
          psmIndication: psmIndication,
          psmIndicationSideeffect: psmIndicationSideeffect,
          psmRestrictionUsePeriod: psmRestrictionUsePeriod,
          abschnitte: abschnitte,
        },
        dataType: 'json',
        success: function(result) {
          if (result.message !== '') {
            mittelUnterdosierungHtml.removeClass('display-none').find('.bodytext').html(result.message);
            dosisProHlGui.addClass('bg-warning');
            sumMittelmengeGui.addClass('bg-warning');
            sumMittelmengeProHaGui.addClass('bg-warning');
          } else {
            mittelUnterdosierungHtml.addClass('display-none');
            mittelUnterdosierungHtml.find('.bodytext').html('');
            dosisProHlGui.removeClass('bg-warning');
            sumMittelmengeGui.removeClass('bg-warning');
            sumMittelmengeProHaGui.removeClass('bg-warning');
          }
        },
      });
    }, 500);
  }
};

/**
 * spritzung_checkUeberdosierung
 */
window.spritzung_checkUeberdosierung = function() {
  if ($('#add-psm-modal').length > 0) {
    setTimeout(function() {
      const mittelUeberdosierungHtml = $('.mittel-ueberdosierung');
      const recordID = $('#app__content').data('id');
      const psmID = $('input.psm_mittel_uid').val();
      const dataKey = $('input.data_key').val();

      const dosisHl = $('input.dosisProHl').val();
      const dosisUnity = $('input.dosage_single_unity').val();

      const psmIndication = $('select.indicationSelect').val();
      const psmIndicationSideeffect = $('input.psm-indication-sideeffect').val();
      const psmRestrictionUsePeriod = $('select.psm_restriction_use_period').val();
      const isTeilspritzung = Number($('input.psm_mittel_teilspritzung').val()) === 1;

      const abschnitte = spritzung_buildAbschnittData(false, isTeilspritzung);

      $.ajax({
        type: 'POST',
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.checkUeberdosierung?type=spritzung',
        async: true,
        data: {
          recordID: recordID,
          psmID: psmID,
          dataKey: dataKey,
          dosisHl: dosisHl,
          dosisUnity: dosisUnity,
          psmIndication: psmIndication,
          psmIndicationSideeffect: psmIndicationSideeffect,
          psmRestrictionUsePeriod: psmRestrictionUsePeriod,
          abschnitte: abschnitte,
        },
        dataType: 'json',
        success: function(result) {
          if (result.message !== '') {
            mittelUeberdosierungHtml.removeClass('display-none').find('.bodytext').html(result.message);
            $('input:submit').attr('disabled', true);
          } else {
            mittelUeberdosierungHtml.addClass('display-none');
            mittelUeberdosierungHtml.find('.bodytext').html('');
            $('input:submit').attr('disabled', false);
          }
        },
      });
    }, 500);
  }
};

/**
 *
 * @param select
 * @param val
 */
window.spritzung_changeAusbringungsmethode = function(select, val) {
  const selected = $(select).find(':selected');
  if ($(selected).hasClass('rueckenspritze')) {
    $('#select-ausbringungsmethode').val(val);
  }
};

/**
 * spritzung_saveTeilspritzungFlaechen
 *
 * @param psmID
 * @param dataKey
 */
window.spritzung_saveTeilspritzungFlaechen = function(psmID, dataKey) {
  event.preventDefault();
  let abschnitteIDs = [];
  const psmRow = $('.psm-mittel-row');
  const abschnitteSelect = $('#tree-select-teilspritzung-abschnitte');

  abschnitteSelect.find('.check_section-teilspritzung:checked').each(function() {
    abschnitteIDs.push($(this).val());
  });

  if (abschnitteSelect.find('input.check_tertiary:checked').length === abschnitteSelect.find('input.check_tertiary').length || Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 0) {
    psmRow.find('input.psm_mittel_teilspritzung').val(0);
    psmRow.find('input.psm_teilspritzung_sections').val('');
    $('.accordion__item[data-step=2a-'+ dataKey + '-' + psmID + ']').remove();
  } else {
    if ($('#tree-aufzeichnungen-teilspritzung-' + dataKey + '-' + psmID).length > 0) {
      $('#tree-aufzeichnungen-teilspritzung-' + dataKey + '-' + psmID).find('input:checked').each(function() {
        $(this).prop('checked', false);
      });
      checkAbschnitte(abschnitteSelect, psmID);
    } else {
      // neuen Step 2a hinzufügen
      // Ajax-Call
      $.ajax({
        url: BASE_PATH + 'ajax/helper/aufzeichnungen/ajax.contentAnbauflaechenTeilspritzung',
        type: 'post',
        data: {
          psmID,
          dataKey,
            psmName:psmRow.find('input.smittel').val(),
          checked: abschnitteIDs,
          recordID: psmRow.find('input.psm_recordID').val(),
        },
        success: function(response) {
          $(response).insertBefore('div.accordion__item[data-step=2-1]');
          checkAbschnitte(abschnitteSelect, psmID);
          spritzung_bindChangeAccordionText();
        },
      });
    }
  }

  /**
   * checkAbschnitte
   *
   * @param abschnitteSelect
   * @param psmID
   */
  function checkAbschnitte(abschnitteSelect, psmID) {
    abschnitteSelect.find('.check_section-teilspritzung:checked').each(function() {
      $('#teilspritzung-' + psmID + '-abschnitt-' + $(this).val()).prop('checked', true);

      // Brühmenge übernehmen
      let thirdLevel = $('.third-level[data-teilspritzung-section-uid=' + $(this).val() + ']');
      let bruehmengeAbschnitt = $('.third-level[data-section-uid=' + $(this).val() + ']').find('input.abschnitt-bruehmenge-intern').val();
      thirdLevel.find('input.abschnitt-bruehmenge-intern').val(bruehmengeAbschnitt);
      thirdLevel.find('input.abschnitt-bruehmenge').val(roundBrueheGui(bruehmengeAbschnitt));

      $('#teilspritzung-' + psmID + '-anlage-' + thirdLevel.data('secondary')).prop('checked', true);
      $('#teilspritzung-' + psmID + '-betrieb-' + thirdLevel.data('primary')).prop('checked', true);
    });

    $('.psm_teilspritzung_sections').val(abschnitteIDs.join(','));

    const psmRow = $('.psm-mittel-row');
    spritzung_calc(spritzung_buildAbschnittData(false, Number(psmRow.find('input.psm_mittel_teilspritzung').val()) === 1), {
      type: 'SUMME_DOSIS_PRO_HL_CHANGING',
      previewData: true,
      mittelId: psmRow.data('psm-id'),
      mittelKey: psmRow.data('key'),
      dosisProHl: psmRow.find('input.dosisProHlGui').val(),
    });

    spritzung_checkUnterdosierung();
    spritzung_checkUeberdosierung();
  }
};

/**
 * resetTeilspritzungAuswahl
 */
window.resetTeilspritzungAuswahl = function() {
  const psmRow = $('.psm-mittel-row');
  psmRow.find('input.psm_mittel_teilspritzung').val(0);
  psmRow.find('input.psm_teilspritzung_sections').val('');
  $('#list_aufzeichnungSelectFlaechenTeilspritzung').addClass('display-none');
};

